import type { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { fredLatestSyncRunQueryKey } from "../fred.keys";

export const useFetchFredLatestSyncRun = () => {
	const { get } = useRequest();

	return useQuery({
		queryKey: fredLatestSyncRunQueryKey(),
		queryFn: async () =>
			await get<Dtos.MarketIntelligence.Fred.GetLatestSyncRun.Response>(
				"/v2/admin/market-intelligence/fred/sync-runs/latest",
			),
	});
};
